import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Template from './template';
import { ServiceInterviewNotice } from 'components';
import { apiServiceInterviewAnswer } from 'api/ZimssaAPI';
import { useServiceStatus } from 'hooks';
import { SERVICE_SELECT } from 'router/PageUrl';

function ServiceInterviewNoticeView(): React.ReactElement {
    const history = useHistory();
    const { serviceIdx, serviceType, serviceState } = useServiceStatus();
    const { interviewDate, serviceStatusHistoryList } = serviceState;
    const interviewAnswerDate: string | undefined = serviceStatusHistoryList.find((item) => item.serviceDocStatus === 'interview_answer')?.createDate;

    const onClickCallback = useCallback(
        (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            apiServiceInterviewAnswer(serviceType, serviceIdx)
                .then((response) => {
                    const { result, message } = response;
                    if (result === 'success') {
                        alert('인터뷰 참여 신청을 하였습니다.');
                        history.push(SERVICE_SELECT.url);
                    } else {
                        if (message) alert(message);
                    }
                })
                .catch((error) => {});
        },
        [history, serviceIdx, serviceType]
    );

    const interviewNoticeProps = {
        interviewDate: interviewDate,
        isAnswer: interviewAnswerDate ? true : false,
        onClick: onClickCallback,
    };

    return (
        <Template>
            <ServiceInterviewNotice {...interviewNoticeProps} />
        </Template>
    );
}

export default ServiceInterviewNoticeView;
